import { CartStatusType } from '@notino/shared/__generated__/globalSPATypes';

import { AddToCartProductErrors } from '@sharedComponents/AddToCartButton/model';
import {
  parseStatusesDeprecated,
  generateNotificationMessageDeprecated,
  parseStatuses,
  generateNotificationMessageForProduct,
} from '@sharedComponents/AddToCartButton/utils';

import { IAddToCartResult, IDeprecatedAddToCartResult } from '../model';

import { getSettings } from './getSettings';

export const addToCartResultDeprecated = ({
  data: { CartAddProductWithService },
  showAddToCartModal,
  disableRedirect,
  product,
}: IDeprecatedAddToCartResult) => {
  const response = CartAddProductWithService.productAddResponse;
  const cartSettings = getSettings(showAddToCartModal, disableRedirect);

  if (
    response.status !== CartStatusType.NotFound &&
    response.status !== CartStatusType.Error
  ) {
    return {
      success: true,
      cartSettings,
      statusMessages: parseStatusesDeprecated(CartAddProductWithService),
    };
  }

  return {
    success: false,
    notificationMessage: generateNotificationMessageDeprecated(
      response.products,
      [product]
    ),
  };
};

export const nonFatalAddToCartProductErrors = [
  AddToCartProductErrors.SC_INSURANCE_ADD_ERROR,
  AddToCartProductErrors.SC_ECO_PACKAGING_ADD_ERROR,
];

export const addToCartResult = ({
  response,
  showAddToCartModal,
  disableRedirect,
  product,
  count,
}: IAddToCartResult) => {
  const cartSettings = getSettings(showAddToCartModal, disableRedirect);
  const { messages } = response.productAddResponse;
  const fatalErrors = messages.filter(
    (m) => !nonFatalAddToCartProductErrors.includes(m as AddToCartProductErrors)
  );

  if (fatalErrors.length > 0) {
    return {
      success: false,
      cartSettings,
      notificationMessage: generateNotificationMessageForProduct(
        fatalErrors,
        product
      ),
    };
  }

  return {
    success: true,
    cartSettings,
    statusMessages: parseStatuses(response, count),
  };
};
